import { createSlice } from '@reduxjs/toolkit';
import { ProviderDetailStateType } from 'src/types/providerDetail';

const initialState: ProviderDetailStateType = {
    data: null,
    loading: false,
    error: false,
};
export const providerDetailSlice = createSlice({
    name: 'providerDetail',
    initialState,
    reducers: {
        getProviderDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getProviderDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        getProviderDetailFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        createProviderDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        createProviderDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        createProviderDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        updateProviderDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        updateProviderDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        updateProviderDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        clearProviderDetail: () => initialState,
    },
});

export const {
    getProviderDetailFetch,
    getProviderDetailFetchSuccess,
    getProviderDetailFetchFailure,
    createProviderDetailFetch,
    createProviderDetailFetchSuccess,
    createProviderDetailFetchFailure,
    updateProviderDetailFetch,
    updateProviderDetailFetchSuccess,
    updateProviderDetailFetchFailure,
    clearProviderDetail,
} = providerDetailSlice.actions;

export default providerDetailSlice.reducer;
